export default {
  setState(state, payload) {
    for (const key in payload) {
      state.cartState[key] = payload[key];
    }
    return state;
  },
};
